import React, { Component } from 'react';

import MonitorCheck from './MonitorCheck';
import CreateItem from '../../../Common/Partials/CreateItem';
import FetchData from '../../../Framework/Fetch';

type Props = {
  fields: any,
  record: any
};

class MonitorChecks extends Component<Props> {
  handleRemove = (e, index) => {
    this.props.fields.remove(index);
    this.props.record.checks.splice(index, 1);
  }

  render() {
    return (
      <div>
        {this.props.fields.length > 0 && this.props.fields.map((item, index) => {
          return (
            <div key={index}>
              <MonitorCheck
                fields={this.props.fields}
                handleRemove={this.handleRemove}
                index={index}
                item={item}
                record={this.props.record} />
              <br />
            </div>
          )
        })}
        <div style={{ paddingTop: 20 }}>
          <CreateItem fields={this.props.fields} label="Add Monitor Check" />
        </div>
      </div>
    )
  }
};

export default MonitorChecks;



// WEBPACK FOOTER //
// ./src/views/Components/Monitors/Partials/MonitorChecks.tsx